import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILottieLoadPayload } from './types';

export interface ILottieState {
  // Add state properties as needed
  ready: boolean;
}

export const initialState: ILottieState = {
  ready: false,
};

export const statePropName = 'lottie';

const lottieSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initLottie: (state, action: PayloadAction<string>) => {
      state.ready = true;
    },
    lottieLoad: {
      reducer: (state, action: PayloadAction<ILottieLoadPayload>) => {},
      prepare: (
        name: string,
        autoplay?: boolean,
        loop?: boolean,
        dontKeep?: boolean,
        id?: string,
        stopOn?: number
      ) => ({
        payload: {
          name,
          autoplay,
          loop,
          dontKeep,
          id,
          stopOn,
        },
      }),
    },
    lottieDestroy: (state, action: PayloadAction<string>) => {},
    lottieLoaded: (state, action: PayloadAction<string>) => {},
    lottieStart: (state, action: PayloadAction<string>) => {},
    lottieComplete: (state, action: PayloadAction<string>) => {},
    lottieForceCache: (state, action: PayloadAction<string>) => {},
  },
});

export const LottieActions = lottieSlice.actions;
export default lottieSlice.reducer;
